import { Injectable } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { CalculationStepRoutes, CalculationTypeRoutes } from '../../../calculation/calculation.constants';
import { capitalizeFirst } from '../../shared/helpers/string';
import { BreadcrumbService } from 'xng-breadcrumb';

@Injectable({ providedIn: 'root' })
export class ChangeTitleService {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private title: Title,
    private meta: Meta,
    private breadcrumbService: BreadcrumbService,
  ) {}

  public changeTitle() {
    const defaultBreadcrumb = 'Calculator acoperiș Bilka și Wetterbest';
    const defaultMetaDescription =
      'Află cât costă acoperișul tău în 2 minute ! Comandă acum online un sistem complet Bilka sau Wetterbest.';

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.snapshot.firstChild;
          if (!child) {
            return this.activatedRoute.snapshot.data.title || `${defaultBreadcrumb}`;
          }

          while (child.firstChild) {
            child = child.firstChild;
          }

          let title = '';
          let metaDescription = '';
          const typeRoute = child.params.roofType as CalculationTypeRoutes | null;
          const stepRoute = child.params.step as CalculationStepRoutes | null;
          const surface = child.params.surface ? child.params.surface : '';

          if (child.data.title) {
            title += `${child.data.title}`;
            title = child.data.title
              ?.replaceAll('{{roofType}}', typeRoute?.replace('-', ' '))
              ?.replaceAll('{{step}}', capitalizeFirst(stepRoute))
              ?.replaceAll('{{surface}}', surface);
            metaDescription = child.data.metaDescription
              ?.replaceAll('{{roofType}}', `în ${typeRoute?.replace('-', ' ')}`)
              ?.replaceAll('{{step}}', stepRoute?.replace('-', ' '))
              ?.replaceAll('{{surface}}', surface);
          }
          return {
            title: (title ? title : defaultBreadcrumb) + ' - ExpertTabla.ro',
            meta: metaDescription ?? (child.data.metaDescription || defaultMetaDescription),
            route: this.router.url,
            breadcrumb: child.data.breadcrumb?.replace('{{surface}}', surface),
          };
        }),
      )
      .subscribe(({ title, meta, route, breadcrumb }) => {
        this.title.setTitle(title);
        this.meta.updateTag({ content: meta, name: 'description' });
        this.meta.updateTag({ content: title, name: 'title' });
        this.breadcrumbService.set(route, breadcrumb);
      });
  }
}
